import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useCompositorView } from '@/components/Recipe/FlowContext';
import { FlipHorizontalIcon, FlipVerticalIcon, Rotate90ClockwiseIcon } from '@/UI/Icons';
import type { MouseEvent } from 'react';
import type { NodeId, LayerId, Orientation } from '@/designer/designer';
import type { Layer } from 'web';

type QuickTransform = 'rotate-cw' | Orientation;

export const FlipLayerButtons = ({ layerId, nodeId, layer }: { layerId: LayerId; nodeId: NodeId; layer: Layer }) => {
  const compositorView = useCompositorView(nodeId);
  const handleChange = (_event: MouseEvent, value: QuickTransform | null) => {
    if (!value) {
      return;
    }
    if (value === 'rotate-cw') {
      compositorView.rotateLayer90Clockwise(layerId);
    } else {
      compositorView.flipLayer(layerId, value);
    }
  };

  return (
    <ToggleButtonGroup value={null} exclusive onChange={handleChange} size="small" disabled={layer.locked}>
      <LayerToggleButton value="rotate-cw" aria-label="Rotate 90° clockwise">
        <Rotate90ClockwiseIcon />
      </LayerToggleButton>
      <LayerToggleButton value="horizontal" aria-label="Flip horizontal">
        <FlipHorizontalIcon />
      </LayerToggleButton>
      <LayerToggleButton value="vertical" aria-label="Flip vertical">
        <FlipVerticalIcon />
      </LayerToggleButton>
    </ToggleButtonGroup>
  );
};

const LayerToggleButton = styled(ToggleButton)(() => ({
  height: '26px',
  padding: '6px',
}));
